import { ButtonPopup, CircleLoadingArrowIcon, LoadingIndicator } from '@isdd/idsk-ui-kit'
import classnames from 'classnames'
import React, { cloneElement, JSX, ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from '@isdd/metais-common/components/actions-over-table/actionsOverTable.module.scss'
import spinnerStyles from '@isdd/idsk-ui-kit/loading-indicator/loadingIndicator.module.scss'

type ResolveItemsFn = (closePopup: () => void) => Promise<ReactElement[]>

export interface IAsyncBulkPopupProps {
    popupPosition: 'left' | 'right' | 'center'
    label: string
    resolveItems: ResolveItemsFn
    limitWidthForMobile?: boolean
    disabled?: boolean
    checkedRowItems?: number
}

export const AsyncBulkPopup: React.FC<IAsyncBulkPopupProps> = ({ resolveItems, ...props }) => {
    const { t } = useTranslation()

    const [items, setItems] = useState<JSX.Element[]>([])
    const [loading, setLoading] = useState(false)

    const handleOpen = async (closePopup: () => void) => {
        setLoading(true)
        const resolved = await resolveItems(closePopup)
        setItems(resolved)
        setLoading(false)
    }

    return (
        <div className={classnames(styles.mobileOrder3, styles.buttonPopup)} id="bulkActions">
            <ButtonPopup
                {...props}
                buttonLabel={`${props.label ? props.label : t('actionOverTable.actions')} ${props.checkedRowItems ? '(' + props.checkedRowItems + ')' : ''}`}
                buttonClassName="marginBottom0"
                onOpen={handleOpen}
                popupContent={(closePopup, focusTrigger) => (
                    <div className={styles.popupActions} id="bulkActionsList" role="list">
                        {loading && (
                            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <img className={spinnerStyles.spinner} src={CircleLoadingArrowIcon} alt="" />
                            </div>
                        )}

                        {!loading &&
                            items.map((item) =>
                                cloneElement(item, {
                                    role: 'listitem',
                                    className: styles.buttonLinkWithIcon,
                                }),
                            )}
                    </div>
                )}
            />
        </div>
    )
}
